import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazySystemOperationsPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SystemOperationsPage" */ '../src/SystemOperations/SystemOperationsPage.tsx'
			)
		).SystemOperationsPage,
});
